import { phoneFormat } from "utils/format";

import { IHandleInputChangeProps } from "../interfaces";

export const HandleInputChange = ({
  event, setState
}: IHandleInputChangeProps) => {
  const { name, value } = event.target;

  switch (name) {
    case "cellphone": {
      setState(prevState => ({
        ...prevState,
        cellphone: phoneFormat(value)
      }));
      break;
    }
    default: {
      setState(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  }
}
